export default {
    purchased: 'Købes',
    sold: '​Sælges',
    forRent: '​Udlejes',
}


// WEBPACK FOOTER //
// ./web/src/common/machineSellTypes.js